'use strict';

namespace Core {
    class CheckboxAll {
        // Attr
        list: any[];

        constructor (
            private $scope: ng.IScope
        ) {
        }

        init(el): void {
            const checkbox: ng.IAugmentedJQuery = el;

            // watch checkbox changes
            checkbox.change(() => {
                // empty the list
                this.$scope.$apply(() => this.list.splice(0, this.list.length));
            });

            // watch the list
            this.$scope.$watchCollection('ca.list', (list) => {
                if (list) {
                    // if list has items then check and disable the checkbox
                    const checked = (this.list.length === 0);
                    checkbox.prop('checked', checked);
                    checkbox.prop('disabled', checked);
                }
            });
        }

    }
    angular
        .module('core')
        .directive('checkboxAll', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: CheckboxAll,
                controllerAs: 'ca',
                bindToController: {
                    list: '=checkboxAll'
                },
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attrs: ng.IAttributes,
                    controller : CheckboxAll
                ) => {
                    controller.init(el);
                }
            };
        });
}
